// PRODUCT PAGE
// listener variant selector
// en global.js lanzmos una funcion cada vez que hay un change de variante
function pangoChangeVariantListener(){
  setTimeout(()=>{
    let nombreDeLaSectionSinPuntoLiquid = 'main-product'
    const url = new URL(window.location);
    url.searchParams.append('section_id', nombreDeLaSectionSinPuntoLiquid )
    const urlString = url.toString();
  
    fetchH1(urlString)    
},500)
}

// como que el fetch no me devuelve el h1, 
// en main-product.liquid guardo el h1 en un attributo data-pango-h1
// y se utiliza para pintar el nuevo texto
async function fetchH1(variantUrl){
    let response = await fetch(variantUrl);
    if(!response.ok) throw new Error(response.status);
    
    let responseText = await response.text();
    let htmlMarkup = new DOMParser().parseFromString(responseText,'text/html')
    let newH1 = htmlMarkup.querySelector('[data-pango-h1]').dataset.pangoH1;

    let h1Element = document.querySelector('h1')
    h1Element.innerHTML=newH1;
}